/*@ngInject*/
const UserSelectionModalController = function ($rootScope, $scope, coreConstant, dataSetUtil, userRepository) {

    $scope.viewModel = {
        selectedGroup: 1,
        selectedUser: null,
        groups: {
            responsibleUnderwriters: 1,
            assignedUnderwriters: 2,
            serviceTeam: 3
        },

        selectedResponsibleUnderwriter: null,
        responsibleUnderwritersList: [],

        selectedAssignedUnderwriter: null,
        assignedUnderwritersList: [],

        selectedServiceTeam: null,
        serviceTeamList: [],
        selectedServiceTeamOptionList: [],

        selectedServiceTeamAddition: null,
        selectedServiceTeamRemoval: null

    };

    dataSetUtil.getDataSet({name: 'Active Underwriters Optional'}).then(function (dataSet) {
        const datasetList = _.sortBy(dataSet.items, (item) => {
            return item.name;
        });

        $scope.viewModel.responsibleUnderwritersList = _.filter(datasetList, (item) => {
            // filter out the unassigned value
            return item.value !== '0';
        });

        $scope.viewModel.assignedUnderwritersList = _.clone(datasetList);
    });

    dataSetUtil.getDataSet({name: 'Service Team User Types'}).then(function (dataSet) {
        $scope.viewModel.serviceTeamList = _.sortBy(dataSet.items, (item) => {
            return item.name;
        });
    });

    $scope.onResponsibleUnderwriterChange = function (selectedOption) {
        if (!selectedOption.roles) {
            $scope.getUserRoles(selectedOption).then(function(roles) {
                if (roles) {
                    selectedOption.roles = roles;
                    selectedOption.name += ' (' + roles + ')';
                }
                $scope.viewModel.selectedResponsibleUnderwriter = selectedOption;
            });
        }
        else {
            $scope.viewModel.selectedResponsibleUnderwriter = selectedOption;
        }
        $scope.viewModel.selectedUser = selectedOption;
    };

    $scope.onAssignedUnderwriterChange = function (selectedOption) {
        if (!selectedOption.roles) {
            $scope.getUserRoles(selectedOption).then(function(roles) {
                if (roles) {
                    selectedOption.roles = roles;
                    selectedOption.name += ' (' + roles + ')';
                }
                $scope.viewModel.selectedAssignedUnderwriter = selectedOption;
            });
        }
        else {
            $scope.viewModel.selectedAssignedUnderwriter = selectedOption;
        }
        $scope.viewModel.selectedUser = selectedOption;

    };

    $scope.onServiceTeamChange = function (selectedOption) {
        $scope.viewModel.selectedServiceTeam = selectedOption;
        $scope.viewModel.selectedServiceTeamAddition = null;
        $scope.viewModel.selectedServiceTeamRemoval = null;

        dataSetUtil.getDataSet({name: `Service Team Users - ${selectedOption.name}`}).then(function (dataSet) {
            $scope.viewModel.selectedServiceTeamOptionList = _.sortBy(dataSet.items, (item) => {
                return item.name;
            });
        });
    };

    $scope.onServiceTeamAdditionChange = function (selectedOption) {
        $scope.viewModel.selectedServiceTeamAddition = selectedOption;
        $scope.viewModel.selectedUser = selectedOption;
    };

    $scope.onServiceTeamRemovalChange = function (selectedOption) {
        $scope.viewModel.selectedServiceTeamRemoval = selectedOption;
        $scope.viewModel.selectedUser = selectedOption;
    };

    $scope.onSelectedGroupChange = function () {
        $scope.viewModel.selectedResponsibleUnderwriter = null;
        $scope.viewModel.selectedAssignedUnderwriter = null;
        $scope.viewModel.selectedServiceTeam = null;
        $scope.viewModel.selectedServiceTeamAddition = null;
        $scope.viewModel.selectedServiceTeamRemoval = null;
        $scope.viewModel.selectedUser = null;
    };

    $scope.isContinueButtonDisabled = function () {
        const hasSelection = $scope.viewModel.selectedUser;
        const isServiceGroupSelected = $scope.viewModel.selectedGroup === $scope.viewModel.groups.serviceTeam;
        const hasAdditionSelection = $scope.viewModel.selectedServiceTeamAddition;
        const hasRemovalSelection = $scope.viewModel.selectedServiceTeamRemoval;

        let result = false;

        if(isServiceGroupSelected) {
            result = !hasAdditionSelection && !hasRemovalSelection;
        }
        else {
            result = !hasSelection;
        }
        return result;
    };

    $scope.onConfirm = function () {
        const result = {};

        const {
            selectedGroup,
            selectedResponsibleUnderwriter,
            selectedAssignedUnderwriter,
            selectedServiceTeamAddition,
            selectedServiceTeamRemoval,
            groups
        } = $scope.viewModel;

        if(selectedGroup === groups.responsibleUnderwriters) {
            result.assignementType = 'Responsible Underwriter';
            result.userToAssignId = parseInt(selectedResponsibleUnderwriter.value);
        }
        else if(selectedGroup === groups.assignedUnderwriters) {
            result.assignementType = 'Assigned To Underwriter';
            result.userToAssignId = parseInt(selectedAssignedUnderwriter.value);
        }
        else if(selectedGroup === groups.serviceTeam) {
            result.assignementType = 'Service User';

            if(selectedServiceTeamRemoval) {
                result.userToRemoveId = parseInt(selectedServiceTeamRemoval.value);
            }

            if (selectedServiceTeamAddition) {
                result.userToAssignId = parseInt(selectedServiceTeamAddition.value);
            }
        }

        $scope.$close(result);
    };

    $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
        $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
    });

    $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);

    $scope.getUserRoles = function (item) {
        if (item && item.value) {
            // item.value should be the user id
            return userRepository.getUserRolesById(item.value);
        }
        else {
            return null;
        }
    };
};

angular.module('umCore')
    .controller('userSelectionModalController', UserSelectionModalController);
